export default __webpack_public_path__ + "static/media/placeholder.798b514d.jpeg";